import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { State } from "@progress/kendo-data-query";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { FormInstanceHistoryGridData } from '../models/form-instance-history-grid-data.model';
import { ProgressIndicatorService } from './progress-indicator.service';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FormInstanceHistoryService extends BehaviorSubject<FormInstanceHistoryGridData>{
    private url = environment.apiUrl;
    private endpoint: string = 'api/formInstanceHistory';
    loading: boolean;
    gridData: FormInstanceHistoryGridData;

    public constructor(private http: HttpClient, progressIndicatorService: ProgressIndicatorService) {
        super(new FormInstanceHistoryGridData);
    }

    public read(formInstanceId: number, gridState: State): void {
        this.fetch(formInstanceId, gridState)
            .pipe(
                tap((data) => {
                    this.gridData = data;
                    this.loading = false;
                })
            )
            .subscribe((data) => {
                super.next(data);
            });
    }

    public getBaseGridDownloadUrl(): string{
        let baseUrl = this.url.endsWith('/') ? this.url : `${this.url}/`;
        let url = `${baseUrl}${this.endpoint}/GetGridVersionCsv`;
        return url;
    }

    public getGridVersionCsv(formInstanceElementId: number, formInstanceElementVersionId: number) {
        let baseUrl = this.url.endsWith('/') ? this.url : `${this.url}/`;
        let url = `${baseUrl}${this.endpoint}/GetGridVersionCsv/${formInstanceElementId}/${formInstanceElementVersionId}`;

        return this.http.get(url).toPromise().then(x => {
            return x;
        });
    }

    private fetch(formInstanceId: number, gridState: State): Observable<FormInstanceHistoryGridData> {
        let baseUrl = this.url.endsWith('/') ? this.url : `${this.url}/`;
        let url = `${baseUrl}${this.endpoint}/GetFormInstanceHistory/${formInstanceId}`;

        let payload = {
            formInstanceId: formInstanceId,
            gridState: gridState
        };

        return <Observable<FormInstanceHistoryGridData>><unknown>this.http.post<FormInstanceHistoryGridData>(url, gridState)
            .pipe(
                map((res) => {
                    return res;
                })
            );
    }
}
